import {useMemo} from "react";
import {useTheme} from "@mui/material/styles";

const withSmallSize = (outer, name) => ({
    ...outer.components?.[name],
    defaultProps: {...outer.components?.[name]?.defaultProps, size: 'small'},
});

/** Тема с компактными полями (size="small") — для конструкторов кампаний / AB-тестов. */
export const compactFormTheme = (outer) => ({
    ...outer,
    components: {
        ...outer.components,
        MuiTextField: withSmallSize(outer, 'MuiTextField'),
        MuiAutocomplete: withSmallSize(outer, 'MuiAutocomplete'),
        MuiFormControl: withSmallSize(outer, 'MuiFormControl'),
    },
});

export const useCompactFormTheme = () => {
    const outer = useTheme();
    return useMemo(() => compactFormTheme(outer), [outer]);
};
